import React, { useEffect, useState } from 'react'

var HOURS = [
  '07:00 AM', '08:00 AM', '09:00 AM', '10:00 AM', '11:00 AM',
  '12:00 PM', '01:00 PM', '02:00 PM', '03:00 PM', '04:00 PM',
  '05:00 PM', '06:00 PM', '07:00 PM', '08:00 PM', '09:00 PM'
]

var HOUR_VALUES = [
  '07:', '08:', '09:', '10:', '11:',
  '12:', '13:', '14:', '15:', '16:',
  '17:', '18:', '19:', '20:', '21:'
]

var TIME_OPTIONS = [
  { value: 'all', label: 'Todo' },
  { value: 'today', label: 'Hoy' },
  { value: 'tomorrow', label: 'Mañana' },
]

function getInitialTime() {
  if (typeof document === 'undefined') return 'all'
  var el = document.getElementById('time-selector')
  return el ? el.value : 'all'
}

function getInitialHour() {
  if (typeof document === 'undefined') return 'all'
  var el = document.getElementById('hour-selector')
  return el ? el.value : 'all'
}

function triggerFilter() {
  if (typeof window.queueFilterData === 'function') {
    window.queueFilterData('selection-change', 60, true)
  }
}

function setTimeValue(val) {
  var el = document.getElementById('time-selector')
  if (el) el.value = val
}

function setHourValue(val) {
  var el = document.getElementById('hour-selector')
  if (el) el.value = val
}

export default function TimeFilter() {
  var [timeVal, setTimeVal] = useState(getInitialTime)
  var [hourVal, setHourVal] = useState(getInitialHour)

  useEffect(function () {
    setTimeValue(timeVal)
  }, [timeVal])

  useEffect(function () {
    setHourValue(hourVal)
  }, [hourVal])

  function pickTime(val) {
    setTimeVal(val)
    setTimeValue(val)
    setTimeout(triggerFilter, 0)
  }

  function pickHour(val) {
    setHourVal(val)
    setHourValue(val)
    setTimeout(triggerFilter, 0)
  }

  return (
    <div className="space-y-3">
      {/* Time filter: Hoy / Mañana / Todo */}
      <div className="flex items-center bg-slate-100 rounded-xl p-1 gap-0">
        {TIME_OPTIONS.map(function (opt) {
          var isActive = timeVal === opt.value
          return (
            <button
              key={opt.value}
              onClick={function () { pickTime(opt.value) }}
              className={[
                'flex-1 text-center text-sm font-semibold py-2 px-4 rounded-lg transition-all cursor-pointer',
                isActive
                  ? 'bg-white text-slate-900 shadow-xs'
                  : 'text-slate-500 hover:text-slate-700'
              ].join(' ')}
            >
              {opt.label}
            </button>
          )
        })}
      </div>

      {/* Hour filter: horizontal scrollable picker */}
      <div className="flex gap-1.5 overflow-x-auto pb-1">
        <button
          onClick={function () { pickHour('all') }}
          className={[
            'shrink-0 text-sm font-semibold py-1.5 px-3 rounded-lg transition-all cursor-pointer whitespace-nowrap',
            hourVal === 'all'
              ? 'bg-white text-slate-900 shadow-xs ring-1 ring-slate-200'
              : 'bg-slate-100 text-slate-500 hover:text-slate-700'
          ].join(' ')}
        >
          Cualquier hora
        </button>
        {HOURS.map(function (label, i) {
          var val = HOUR_VALUES[i]
          var isActive = hourVal === val
          return (
            <button
              key={val}
              onClick={function () { pickHour(val) }}
              className={[
                'shrink-0 text-sm font-semibold py-1.5 px-3 rounded-lg transition-all cursor-pointer whitespace-nowrap',
                isActive
                  ? 'bg-white text-slate-900 shadow-xs ring-1 ring-slate-200'
                  : 'bg-slate-100 text-slate-500 hover:text-slate-700'
              ].join(' ')}
            >
              {label}
            </button>
          )
        })}
      </div>
    </div>
  )
}